import cx from 'classnames';
import useAddOnsInfo from '../../hooks/useAddOnsInfo';
import styles from './AddOnsInfoV2.module.scss';
import Button from '../../components/Button';
import {
  ADD_ONS_PRODUCT_BASE_NAME,
  BASE_TYPE_TO_SHOW_ADD_ONS,
  FABRIC_SEAMLESS_PRODUCTION_CREATION_BASE_TYPE,
  HIDE_CANCEL_REQUEST_FOR_ADDONS_BASE_TYPE_LIST,
  RECURRING_INTERVAL,
  convertStripeCentsToAmount,
  getBillingCycleName,
  getDateFromTimestamp,
  getSubscriptionListForCombinePlanPurchase,
} from './subscriptionHelper';
import MinusIcon from '../../components/icons/MinusIcon';
import PlusIcon from '../../components/icons/PlusIcon';
import { checkIfEmailIsVerifiedOrNot, useUserContext } from '../../contexts/UserContext';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import {
  selectAddOnSuccessFlag,
  selectBillingInfo,
  selectIsCreatorPlan,
  subscriptionActions,
} from '../../redux/slicers/subscriptionSlicer';
import { successToast, warningToast } from '../../helpers/toastHelper';
import { getAppState } from '../../redux/store';
import { CheckoutUIAddons } from '../Pricing/CheckoutUI';
import SubscriptionStatusModal from './SubscriptionStatusModal';
import { useDispatch, useSelector } from 'react-redux';
import PaymentDoneIcon from '../../components/icons/PaymentDone';
import useSubscriptionPurchase from '../../hooks/useSubscriptionPurchase';
import {
  UpgradeToNewPlanPatchV2,
  apiGetAllProductUsedCount,
  setClientSubscriptionPlansV2,
  setFailedClientSubscriptionPlansAndAddOnsV2,
} from '../../api/subscription/subscription';
import { callTrackEvent } from '../../helpers/segmentHelper';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import './../subscriptionComponents/AddOn.scss';
import ManagePlanAndPaymentBanner from './ManagePlanAndPaymentBanner';
import {
  MATTRESS_BUILDER_BASE_TYPE,
  TEXTURE_BASE_TYPE,
  THREE_3D_MODAL_BASE_TYPE,
} from '../../constants/constants';
import { userPilotEvents } from '../../common/Userpilot/userpilotHelper';
import { CycleToggle } from './CycleToggle';
import { WarningInfoIcon } from '../../assets/icons';
import { CircularProgress } from '../../common';

export default function AddOnsInfoV2({
  loading: pageLoading,
  showSeparateList = true,
  modifySubscription = false,
  selfServeBillingCycle = false,
  setSelfServeBillingCycle = () => {},
  setModifySubscription,
  openCheckout = null,
  setOpenCheckout = () => {},
  updateCheckoutAmount = null,
  setUpdateCheckoutAmount = () => {},
  innerContainerStyle = {},
  removeMarginTop = null,
  isAddToPlanClickedLoading = false,
  // showLimitedAddons = false,
}) {
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(location.search);
  const checkoutParam = queryParameters.get('checkout');
  const isOfferOnOneTime = queryParameters.get('is_one_time');
  const { isGuestUser } = useUserContext();
  const [checkoutInfo, setCheckoutInfo] = useState(null);
  const {
    userPlans,
    handlePurchasePlanAndAddons,
    checkoutInfo: planCheckoutInfo,
    loading: planLoading,
    sliderValues: planSliderValues,
    currentPlanIsCancelled,
    isMattressBuilderPurchased,
  } = useSubscriptionPurchase();
  const { flag: addOnSuccessFlag, message: addOnSuccessMessage } =
    useSelector(selectAddOnSuccessFlag);
  const { isFreemiumUser, isFreemiumOrSelfServeUser } = useCurrentOrganizationInfo();
  const [totalCartAmount, setTotalCartAmount] = useState(0);
  const [cancelRequestLoader, setCancelRequestLoader] = useState(false);
  const { trackClickEvent } = userPilotEvents();
  const isCreatorPlan = useSelector(selectIsCreatorPlan);

  const {
    billingCycle: _billingCycle,
    setBillingCycle: _setBillingCycle,
    filterAddonsList,
    recurringAddonsList,
    oneTimeAddonsList,
    handleAddAddonCart,
    cartAddonsList,
    loading,
    // handlePurchase,
    handlePurchaseV2,
  } = useAddOnsInfo({
    clearCheckout: () => setCheckoutInfo(null),
  });

  // if user has a creator plan, we use only the billing cycle of the addons
  const billingCycle = isCreatorPlan ? _billingCycle : selfServeBillingCycle || _billingCycle;

  const subscriptionDetails =
    userPlans &&
    userPlans?.find(({ recurring_interval }) => +recurring_interval === +_billingCycle);

  const setBillingCycle = (b) => {
    // if user has a creator plan, we don't want to change the billing cycle of the SelfServeBillingCycle
    if (!isCreatorPlan) setSelfServeBillingCycle(b);
    _setBillingCycle(b);
  };

  const addonsList = [...recurringAddonsList, ...oneTimeAddonsList];
  const [cartItems, setCartItems] = useState(cartAddonsList || []);

  const goBack = (str, val) => {
    if (str === 'afterPurchase') {
      const _checkoutInfo = [...filterAddonsList].filter((a) => a.quantity > 0);
      addDataToSegment(_checkoutInfo, 'paymentSuccess', val);
    }
    setCheckoutInfo(null);
  };

  const addDataToSegment = async (checkoutInfo, str, val) => {
    let filterCounts = userPlans?.[0]?.included_addons;
    if (!filterCounts?.length) {
      filterCounts = await apiGetAllProductUsedCount();
      filterCounts = filterCounts?.results;
    }
    const textureCount = filterCounts?.find((val) => val.basemodeltype === 'Texture');
    const modelCount = filterCounts?.find((val) => val.basemodeltype === '3D Models Upload Limit');
    const modelVariation = checkoutInfo?.find((val) => val.basemodeltype === '3D Model variation');
    const configurator = checkoutInfo?.find((val) => val.basemodeltype === 'Configurator');
    const video = checkoutInfo?.find((val) => val.basemodeltype === 'Video');
    const editor = checkoutInfo?.find((val) => val.basemodeltype === 'Editor');
    const model = checkoutInfo?.find((val) => val.basemodeltype === '3D Model');
    const arView = checkoutInfo?.find((val) => val.basemodeltype === '360 Viewer + AR');
    const seamless = checkoutInfo?.find((val) => val.basemodeltype === FABRIC_SEAMLESS_PRODUCTION_CREATION_BASE_TYPE);

    const dataForSegment = {
      Editor: editor?.quantity || 0,
      Video: video?.quantity || 0,
      Configurator: configurator?.quantity || 0,
      Current_Plan_Name: userPlans?.length ? userPlans?.[0]?.planDetails?.[0]?.plan_name : 'Free',
      Texture_Limit: textureCount?.total_count || 0,
      Model_Limit: modelCount?.total_count || 0,
    };
    dataForSegment['3D_Model'] = model?.quantity || 0;
    dataForSegment['3D_Model_Variation'] = modelVariation?.quantity || 0;
    dataForSegment['3DViewer_AR'] = arView?.quantity || 0;
    dataForSegment['Fabric_Seamless_Creation'] = seamless?.quantity || 0;

    if (str === 'paymentSuccess') {
      dataForSegment['Subscription_Type'] = val?.billing
        ? getBillingCycleName({ cycle: val?.billing?.interval })
        : 'NA';
      dataForSegment['Total_Amount'] = val?.totalAmt;
      callTrackEvent('Payment success addons', dataForSegment, true);
    } else {
      callTrackEvent('Go to Checkout', dataForSegment, true);
    }
  };

  const readyCheckoutInfo = () => {
    const _checkoutInfo = [...filterAddonsList].filter((a) => a.quantity > 0);
    addDataToSegment(_checkoutInfo);
    setCheckoutInfo(_checkoutInfo);
  };

  useEffect(() => {
    let timerId;
    if (openCheckout) {
      readyCheckoutInfo();

      timerId = setTimeout(() => {
        setOpenCheckout(false);
      }, 5000);
    }

    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [openCheckout]);

  const handleCancelDowngradeRequest = async () => {
    const priceIdList = [];
    if (subscriptionDetails?.plan_details?.length) {
      subscriptionDetails?.plan_details?.forEach((list) => {
        if (
          list?.basemodeltype !== THREE_3D_MODAL_BASE_TYPE &&
          list?.basemodeltype !== TEXTURE_BASE_TYPE && 
          list?.basemodeltype !== ADD_ONS_PRODUCT_BASE_NAME.Editor &&
          list?.is_custom_plan
        ) {
          if (+list?.to_remove_product_quantity > 0) {
            priceIdList.push(list.price_stripe_price_id);
          }
        }
      });
      if (priceIdList.length) {
        return await cancelDowngradeRequestAPI(priceIdList);
      }
    }
    return null;
  };

  const cancelDowngradeRequestAPI = async (data) => {
    if (subscriptionDetails?.id) {
      const payload = {
        cancel_downgrade: true,
        data: data,
      };
      const res = await UpgradeToNewPlanPatchV2(payload, subscriptionDetails?.id);
      if (res?.id) {
        dispatch(setClientSubscriptionPlansV2());
        dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
      }
      return res;
    }
    return null;
  };

  const _handlePurchase = async (args) => {
    const {
      billing_first_name,
      billing_country,
      billing_email,
      billing_pincode,
      billing_city,
      billing_line1,
      billing_line3,
    } = selectBillingInfo(getAppState());

    if (
      !billing_first_name ||
      !billing_country ||
      !billing_email ||
      !billing_pincode ||
      !billing_line3 ||
      !billing_line1 ||
      !billing_city
    ) {
      warningToast('Please fill the billing details to continue.');
      return;
    }

    // handlePurchase(args)
    if (isFreemiumUser)
      handlePurchasePlanAndAddons({
        ...args,
        billingInterval: billingCycle,
        finalCheckoutInfo: {
          planCheckoutInfo,
          addonCheckoutInfo: checkoutInfo,
        },
      });
    else {
      await handleCancelDowngradeRequest();
      handlePurchaseV2(args);
    }
  };

  useEffect(() => {
    setCartItems(
      cartAddonsList?.filter(
        (a) =>
          a.quantity > 0 &&
          filterAddonsList.filter(({ id }) => +a.subscription_price === +id)?.length
      )
    );
    if (checkoutInfo) {
      readyCheckoutInfo();
    }
  }, [cartAddonsList]);

  useEffect(() => {
    let timerId;
    if (cartAddonsList?.length > 0 && checkoutParam && !pageLoading) {
      timerId = setTimeout(() => readyCheckoutInfo(), 0);
    }
    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [cartAddonsList, checkoutParam, isOfferOnOneTime, pageLoading]);

  if (pageLoading) return <Loader loading backdrop />;

  const addSegmentEventAddPlan = (list) => {
    const dataForSegment = {
      Current_Plan_Name: userPlans?.length ? userPlans?.[0]?.planDetails?.[0]?.plan_name : 'Free',
      Add_ons_clicked: list?.basemodeltype,
    };
    callTrackEvent('Add to plan', dataForSegment, true);
  };

  const addToPlanEvent = (list, boolval) => {
    addSegmentEventAddPlan(list);
    trackClickEvent('Add to plan', {
      plan: 'Creator',
      cost: totalCartAmount / 100,
      'Addon type':
        (filterAddonsList?.reduce(
          (a, c) => (!c?.is_one_time || c?.quantity < 1 ? a : `${a}${c?.basemodeltype}, `),
          ''
        ) || '') + list?.name,
      is_yearly: billingCycle === 2,
    });
    handleAddAddonCart(list, boolval);
  };

  const subscriptionList = useMemo(
    () =>
      [...getSubscriptionListForCombinePlanPurchase()]
        .map((a) => {
          if (cartAddonsList?.find((item) => item?.subscription_price === a?.product)) return a;

          return null;
        })
        .filter(Boolean),
    [cartAddonsList, updateCheckoutAmount]
  );

  const calculateTotalCheckoutAmount = useCallback(
    (interval = billingCycle, counts = 1) => {
      let amount = 0;

      const addonsInfo = [...filterAddonsList].filter((a) => a.quantity > 0);

      const _checkoutInfo = [
        ...subscriptionList,
        ...addonsInfo
          ?.filter((item) => {
            if (subscriptionList?.find((a) => a?.basemodeltype === item?.basemodeltype)) {
              return null;
            }
            return item;
          })
          .filter(Boolean),
      ];

      _checkoutInfo?.forEach((_item) => {
        let itemAmount = 0;
        _item?.prices?.forEach((__item) => {
          if (
            _item?.is_one_time ||
            (__item?.recurring_interval === interval &&
              +__item?.recurring_interval_count === +counts)
          ) {
            itemAmount += +__item?.unit_amount;
          }
        });

        amount += itemAmount * _item?.quantity;

        if ('finalAmount' in _item) {
          // the finalAmount key i'm adding for the subscription plan data only
          amount += +_item?.finalAmount;
        }
      });

      setTotalCartAmount(amount);

      return amount;
    },
    [subscriptionList, filterAddonsList, billingCycle]
  );

  useEffect(() => {
    calculateTotalCheckoutAmount();

    return () => setUpdateCheckoutAmount(0);
  }, [subscriptionList, planSliderValues, filterAddonsList, updateCheckoutAmount]);

  const activePlans =
    userPlans?.filter((plan) => !plan.is_cancelled && plan?.status !== 'deleted') || [];
  const planListBaseOnInterval = activePlans?.find(
    ({ recurring_interval }) => +recurring_interval === +billingCycle
  );
  const subscriptionEndDate = getDateFromTimestamp(
    planListBaseOnInterval?.current_period_end_timestamp,
    true
  );

  const cancelAddonsDowngradeRequest = async (data, subscriptionDetails) => {
    if (subscriptionDetails?.id) {
      setCancelRequestLoader(data[0]);
      const payload = {
        cancel_downgrade: true,
        data: data,
      };
      const res = await UpgradeToNewPlanPatchV2(payload, subscriptionDetails?.id);
      setCancelRequestLoader(false);
      if (res) {
        successToast('Request canceled successfully.');
        dispatch(setClientSubscriptionPlansV2());
        dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
      }
      return res;
    }
  };
  
  return (
    <>
      <SubscriptionStatusModal
        isV2={true}
        icon={PaymentDoneIcon}
        show={addOnSuccessFlag}
        heading="Congratulations"
        onClose={() =>
          dispatch(
            subscriptionActions.SetAddOnsSuccessFlag({
              flag: false,
              message: '',
            })
          )
        }
        description={addOnSuccessMessage || 'Your addons have been purchased successfully.'}
      />
      <div
        className={`${styles.addOnsContainer} ${!showSeparateList && !removeMarginTop && 'mt-4'} ${
          !showSeparateList ? styles.addOnsContainerV2 : ''
        }`}>
        {!showSeparateList && addonsList?.length > 0 && (
          <div className={styles.addonsListContainer} style={innerContainerStyle}>
            <div
              className={cx(
                'd-flex justify-content-between align-items-center',
                isCreatorPlan ? 'gap-3 mb-3 flex-wrap' : ''
              )}>
              <h6 className={isCreatorPlan ? 'mb-0' : ''}>
                Expand your capabilities with our powerful Add-Ons
              </h6>
              {isCreatorPlan ? (
                <CycleToggle cycle={billingCycle} setCycle={setBillingCycle} />
              ) : null}
            </div>

            <div className={styles.addonsList}>
              {addonsList?.map((list) => {
                if(!BASE_TYPE_TO_SHOW_ADD_ONS.includes(list?.basemodeltype)){
                    return null
                }
                if (
                  isFreemiumOrSelfServeUser &&
                  list?.basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor
                ) {
                  return null;
                }
                if(isMattressBuilderPurchased && list?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE){
                  return null;
                }
                let monthlyPrice = 0;
                let yearlyPrice = 0;
                let oneTimePrice = 0;
                let quantity = 0;
                const isOneTime = list?.is_one_time;
                const prices =
                  isOneTime && list?.prices?.length > 1 ? [list?.prices?.[0]] : list?.prices;

                prices?.forEach((a) => {
                  if (isOneTime || a?.recurring_interval === RECURRING_INTERVAL.YEAR) {
                    oneTimePrice = convertStripeCentsToAmount(a?.unit_amount);
                    quantity = a?.quantity;
                  }
                  if (
                    a?.recurring_interval === billingCycle &&
                    a?.recurring_interval === RECURRING_INTERVAL.MONTH
                  ) {
                    monthlyPrice = convertStripeCentsToAmount(a?.unit_amount);
                    if (quantity === 0) {
                      quantity = a?.quantity;
                    }
                  }
                  if (
                    a?.recurring_interval === billingCycle &&
                    a?.recurring_interval === RECURRING_INTERVAL.YEAR
                  ) {
                    yearlyPrice = convertStripeCentsToAmount(a?.unit_amount);
                    if (quantity === 0) {
                      quantity = a?.quantity;
                    }
                  }
                });
                return (
                  <div key={list?.id} className={styles.addonItemBox}>
                    <div>
                      {' '}
                      <h3>{list?.name}</h3>
                      {isOneTime ? (
                        <>
                          <span className={styles.priceValue}>${oneTimePrice}</span>
                        </>
                      ) : (
                        <>
                          <span className={styles.priceValue}>${monthlyPrice || yearlyPrice}</span>
                          {monthlyPrice ? (
                            <p className={styles.description}>
                              per add-on/month, when billed yearly
                            </p>
                          ) : yearlyPrice ? (
                            <p className={styles.description}>per add-on/year</p>
                          ) : null}
                        </>
                      )}
                    </div>
                    {!isGuestUser() ? (
                      <div className={styles.actionBtn}>
                        {list?.quantity > 0 ? (
                          <>
                            {list?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE ? (
                              <>
                                <Button
                                  size={'xlg'}
                                  style={{backgroundColor:"#E7E7E7" , color:"#141414", border:"0px" , opacity:"1", display:"flex"}}
                                  onClick={() => handleAddAddonCart(list, false)}>
                                  Remove
                                </Button>
                              </>
                            ) : (
                              <>
                                <div className={styles.qtyBtn}>
                                  <MinusIcon
                                    fill="#2B2A28"
                                    className="cursor-pointer"
                                    onClick={() => handleAddAddonCart(list, false)}
                                  />
                                  <span className={styles.addonsQty}>{list?.quantity} </span>
                                  <PlusIcon
                                    fill="#2B2A28"
                                    className="cursor-pointer"
                                    onClick={() => handleAddAddonCart(list, true)}
                                  />
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <Button
                            size={'xlg'}
                            className="selection-button black-btn"
                            onClick={() => addToPlanEvent(list, true)}>
                            Add to Plan
                          </Button>
                        )}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>

            {planListBaseOnInterval && planListBaseOnInterval?.plan_details?.length > 0 && (
              <>
                {planListBaseOnInterval?.plan_details?.map((list) => {
                  if (
                    HIDE_CANCEL_REQUEST_FOR_ADDONS_BASE_TYPE_LIST.includes(list?.basemodeltype) ||
                    +list?.to_remove_product_quantity < 1
                  )
                    return null;
                  return (
                    <div className={styles.bannerSection}>
                      <p>
                        <span className="me-1">
                          <WarningInfoIcon />
                        </span>
                        {+list?.product_quantity === 0 && +list?.to_remove_product_quantity > 0
                          ? `Your ${
                              list?.basemodeltype
                            } Limit are set to be cancelled, You will have access to ${
                              +list?.product_quantity + +list?.to_remove_product_quantity
                            } ${list?.basemodeltype} until ${subscriptionEndDate}.`
                          : `Your ${
                              list?.basemodeltype
                            } limit are set to be downgraded to ${+list?.to_remove_product_quantity}, You will have access to ${
                              +list?.product_quantity + +list?.to_remove_product_quantity
                            } ${list?.basemodeltype}  until
                      ${subscriptionEndDate}.`}
                      </p>
                      <span
                        onClick={() =>
                          cancelAddonsDowngradeRequest(
                            [list?.price_stripe_price_id],
                            planListBaseOnInterval
                          )
                        }>
                        {cancelRequestLoader === list?.price_stripe_price_id ? (
                          <CircularProgress size={18} thickness={2} />
                        ) : (
                          'Cancel Request'
                        )}
                      </span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}
        {showSeparateList && recurringAddonsList?.length > 0 && (
          <div className={styles.recurringContainer}>
            <h6>Recurring Add-ons</h6>

            <div className={styles.addonsList}>
              {recurringAddonsList?.map((list) => {
                if(isMattressBuilderPurchased && list?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE){
                  return null;
                }
                let monthlyPrice = 0;
                let yearlyPrice = 0;
                let quantity = 0;
                const prices = list?.prices;
                prices?.forEach((a) => {
                  if (a?.recurring_interval === RECURRING_INTERVAL.YEAR) {
                    yearlyPrice = convertStripeCentsToAmount(a?.unit_amount);
                    quantity = a?.quantity;
                  }
                  if (a?.recurring_interval === RECURRING_INTERVAL.MONTH) {
                    monthlyPrice = convertStripeCentsToAmount(a?.unit_amount);
                    if (quantity === 0) {
                      quantity = a?.quantity;
                    }
                  }
                });
                return (
                  <div key={list?.id} className={styles.addonItemBox}>
                    <div>
                      {' '}
                      <h3>{list?.name}</h3>
                      <span className={styles.priceValue}>${monthlyPrice || yearlyPrice}</span>
                      <p className={styles.description}>per add-on/month, when billed yearly</p>
                    </div>
                    {!isGuestUser() ? (
                      <div className={styles.actionBtn}>
                        {list?.quantity > 0 ? (
                          <div className={styles.qtyBtn}>
                            <MinusIcon
                              fill="#2B2A28"
                              className="cursor-pointer"
                              onClick={() => handleAddAddonCart(list, false)}
                            />
                            <span className={styles.addonsQty}>{list?.quantity} </span>
                            <PlusIcon
                              fill="#2B2A28"
                              className="cursor-pointer"
                              onClick={() => handleAddAddonCart(list, true)}
                            />
                          </div>
                        ) : (
                          <Button
                            size={'xlg'}
                            className="selection-button black-btn"
                            onClick={() => addToPlanEvent(list, true)}>
                            Add to Plan
                          </Button>
                        )}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {showSeparateList && oneTimeAddonsList?.length > 0 && (
          <div className={styles.oneTimeAddonsList}>
            <h6>One-time Add-ons</h6>

            <div className={styles.addonsList}>
              {oneTimeAddonsList?.map((list) => {
                if(isMattressBuilderPurchased && list?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE){
                  return null;
                }
                let monthlyPrice = 0;
                let yearlyPrice = 0;
                let quantity = 0;
                const isOneTime = list?.is_one_time;
                const prices =
                  isOneTime && list?.prices?.length > 1 ? [list?.prices?.[0]] : list?.prices;

                prices?.forEach((a) => {
                  if (isOneTime || a?.recurring_interval === RECURRING_INTERVAL.YEAR) {
                    yearlyPrice = convertStripeCentsToAmount(a?.unit_amount);
                    quantity = a?.quantity;
                  }
                  if (a?.recurring_interval === RECURRING_INTERVAL.MONTH) {
                    monthlyPrice = convertStripeCentsToAmount(a?.unit_amount);
                    if (quantity === 0) {
                      quantity = a?.quantity;
                    }
                  }
                });
                return (
                  <div key={list?.id} className={styles.addonItemBox}>
                    <div>
                      {' '}
                      <h3>{list?.name}</h3>
                      <span className={styles.priceValue}>${yearlyPrice || monthlyPrice}</span>
                    </div>
                    {!isGuestUser() ? (
                      <div className={styles.actionBtn}>
                        {list?.quantity > 0 ? (
                          <div className={styles.qtyBtn}>
                            <MinusIcon
                              fill="#2B2A28"
                              className="cursor-pointer"
                              onClick={() => {
                                handleAddAddonCart(list, false);
                              }}
                            />
                            <span className={styles.addonsQty}>{list?.quantity} </span>
                            <PlusIcon
                              fill="#2B2A28"
                              className="cursor-pointer"
                              onClick={() => {
                                handleAddAddonCart(list, true);
                              }}
                            />
                          </div>
                        ) : (
                          <Button
                            size={'xlg'}
                            className="selection-button black-btn"
                            onClick={() => addToPlanEvent(list, true)}>
                            Add to Plan
                          </Button>
                        )}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {modifySubscription && (
          <ManagePlanAndPaymentBanner setModifySubscription={setModifySubscription} />
        )}

        {/* floating cart bar */}
        {!checkoutInfo && cartItems?.length > 0 && (
          <div className={cx('add-ons-checkout checkoutV2', cartItems?.length > 0 ? 'show' : '')}>
            <div
              className={cx(
                'd-flex align-items-center justify-content-between gap-3 flex-wrap',
                'add-ons-checkout-inner',
                !checkIfEmailIsVerifiedOrNot(false) ? 'margin-bottom-space' : ''
              )}>
              <p className="mb-0">
                {cartItems?.length}{' '}
                {!showSeparateList
                  ? ''
                  : `item
              ${cartItems?.length > 1 ? 's' : ''}`}{' '}
                selected
              </p>
              <div className="d-flex align-items-center justify-content-center gap-4">
                <p className={styles.totalAmount}>
                  <span>Total amount:</span>
                  <div className={styles.price}>
                    {isAddToPlanClickedLoading ? (
                      <Loader loading size={18} thickness={2} />
                    ) : (
                      `$${convertStripeCentsToAmount(totalCartAmount)}`
                    )}
                  </div>
                </p>
                <Button
                  size="lg"
                  color="primary"
                  className="ms-auto selection-button"
                  style={{
                    borderRadius: '10px',
                  }}
                  disabled={isAddToPlanClickedLoading}
                  onClick={() => {
                    trackClickEvent('Go to checkout', {
                      plan: 'Creator',
                      cost: totalCartAmount / 100,
                      'Addon type': filterAddonsList?.reduce(
                        (a, c) =>
                          !c?.is_one_time || c?.quantity < 1 ? a : `${a}${c?.basemodeltype}, `,
                        ''
                      ),
                      is_yearly: billingCycle === 2,
                    });
                    readyCheckoutInfo();
                  }}>
                  Go to checkout
                </Button>
              </div>
            </div>
          </div>
        )}

        {checkoutInfo && !isGuestUser() ? (
          <CheckoutUIAddons
            isAddon={true}
            checkoutInfo={checkoutInfo}
            handleAddAddonCart={handleAddAddonCart}
            billingCycle={billingCycle}
            setBillingCycle={setBillingCycle}
            goBack={() => goBack('backClick')}
            handlePurchase={(val) =>
              _handlePurchase({ checkoutInfo, callback: () => goBack('afterPurchase', val) })
            }
            loading={loading || planLoading}
            subscriptionDetails={subscriptionDetails}
            setTotalCartAmount={setTotalCartAmount}
            isCurrentPlanIsCancelled={currentPlanIsCancelled()}
          />
        ) : null}
      </div>
    </>
  );
}
